import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../../aiPluginType';

export const getAreAiEntryPointsDisabled = (
	api: ExtractInjectionAPI<AIPlugin> | undefined,
): boolean => api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false;

export const useAreAiEntryPointsDisabled = (
	api: ExtractInjectionAPI<AIPlugin> | undefined,
): boolean => {
	const { areAiEntryPointsDisabled } = useSharedPluginStateWithSelector(
		api,
		['aiExperience'],
		({ aiExperienceState }) => ({
			areAiEntryPointsDisabled: aiExperienceState?.areAiEntryPointsDisabled ?? false,
		}),
	);

	return areAiEntryPointsDisabled;
};
